import { useState } from 'react';

const CATEGORIAS = {
  senhas:     { label: 'Senhas e acessos',  emoji: '🔐' },
  documentos: { label: 'Documentos',        emoji: '📄' },
  materiais:  { label: 'Materiais de apoio',emoji: '📚' },
  outros:     { label: 'Outros',            emoji: '📁' },
};

function CardAcesso({ doc }) {
  const [revelado, setRevelado] = useState(false);
  const ehSenha = doc.categoria === 'senhas';
  return (
    <div className="card" style={{ padding: 16 }}>
      <div style={{ fontWeight: 700, fontSize: 14, color: 'var(--text-primary)', marginBottom: 8 }}>{doc.titulo}</div>
      {doc.link && (
        <a href={doc.link} target="_blank" rel="noreferrer"
          style={{ display: 'inline-block', marginBottom: 8, fontSize: 12, color: '#4A90D9', fontWeight: 600 }}>🔗 Abrir link</a>
      )}
      {doc.conteudo && (
        !ehSenha ? (
          <div style={{ fontSize: 12.5, whiteSpace: 'pre-wrap', color: 'var(--text-secondary)', lineHeight: 1.6 }}>{doc.conteudo}</div>
        ) : revelado ? (
          <pre style={{ background: 'var(--bg-secondary)', padding: '10px 12px', borderRadius: 8, fontSize: 12.5, whiteSpace: 'pre-wrap', margin: 0, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text-primary)' }}>{doc.conteudo}</pre>
        ) : (
          <button className="portal-revelar" onClick={() => setRevelado(true)}>👁 clique pra revelar</button>
        )
      )}
    </div>
  );
}

export default function PortalAcessos({ acessos }) {
  if (!acessos.length) {
    return <div className="portal-estado">Nada por aqui ainda para este projeto.</div>;
  }

  const grupos = Object.keys(CATEGORIAS).map(key => ({
    key, ...CATEGORIAS[key],
    itens: acessos.filter(a => a.categoria === key),
  })).filter(g => g.itens.length > 0);

  return (
    <div>
      <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginBottom: 14 }}>
        Trate essas informações com cuidado — não encaminhe este link pra ninguém fora da sua equipe.
      </div>
      {grupos.map(g => (
        <div key={g.key} style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--text-secondary)', marginBottom: 10, textTransform: 'uppercase' }}>{g.emoji} {g.label}</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 14 }}>
            {g.itens.map(doc => <CardAcesso key={doc.id} doc={doc} />)}
          </div>
        </div>
      ))}
    </div>
  );
}
